/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {AngularModalService} from '../../common/modal/angular-modal.service';

import {ReleaseNotesModalComponent} from './release-notes-modal.component';

@Injectable({providedIn: 'root'})
export class ReleaseNotesModalService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  open(apps: string[]): void {
    this.angularModalService.show(ReleaseNotesModalComponent, {
      initialState: {apps}
    });
  }
}
